// extracted by mini-css-extract-plugin
module.exports = {"__outline_button":"outlineButtonViceVersa___outline_button__2cNua","__outline_button_icon":"outlineButtonViceVersa___outline_button_icon__1Rj1Z"};